import type { InitOptions, i18n as I18nInstance } from 'i18next';
import { defaultNS, fallbackLng, resources, supportedLocales } from './resources';
export { P2E_ERROR_CODES, type P2EErrorCode, type P2EErrorKey, isP2EErrorKey } from './p2e-error-codes';

export type SupportedLocale = keyof typeof resources;

const baseInitOptions: InitOptions = {
  lng: fallbackLng,
  fallbackLng,
  defaultNS,
  resources,
  supportedLngs: supportedLocales as string[],
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
};

export const createInitOptions = (overrides: InitOptions = {}): InitOptions => ({
  ...baseInitOptions,
  ...overrides,
  interpolation: {
    ...baseInitOptions.interpolation,
    ...overrides.interpolation,
  },
});

export const ensureI18n = async (instance: I18nInstance, overrides?: InitOptions) => {
  if (instance.isInitialized) {
    if (overrides) {
      await instance.init(createInitOptions(overrides));
    }
    return instance;
  }

  await instance.init(createInitOptions(overrides));
  return instance;
};

export { defaultNS, fallbackLng, resources, supportedLocales };

